import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Button,
  IconButton,
  Menu,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TableContainer,
  Paper,
  Table,
  Tooltip,
} from "@mui/material";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import { useSelector } from "react-redux";
import { SlOptions } from "react-icons/sl";
import { useTheme } from "../../ThemeContext";
import { getMyLeaveRequest } from "../../apis/apiService";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import Loader from "../../components/common/Loader";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AddLeave } from "./AddLeave";
import { openInNewTab } from "../../utils/openInNewTab";

function MonthlyReport() {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { isDarkMode } = useTheme();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLeave, setShowLeave] = useState(false);
  const [showLeaveDetails, setShowLeaveDetails] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [leaveFilter, setLeaveFilter] = useState("all");
  const [anchorEl, setAnchorEl] = useState(null);
  const token = localStorage.getItem("access_token");
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [yearFilter, setYearFilter] = useState(dayjs().year());
  const [monthFilter, setMonthFilter] = useState("all");
  const [data, setData] = useState([]);
  const handleShowLeave = () => setShowLeave(true);
  const handleCloseLeave = () => setShowLeave(false);
  const handleShowLeaveDetails = () => setShowLeaveDetails(true);
  const handleCloseLeaveDetails = () => {
    setShowLeaveDetails(false);
    setSelectedLeave(null);
  };
  const handleShowFilter = () => setShowFilter(true);
  const handleCloseFilter = () => setShowFilter(false);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const [expandedDepts, setExpandedDepts] = useState({});

  const toggleDept = (deptId) => {
    setExpandedDepts((prev) => ({
      ...prev,
      [deptId]: !prev[deptId],
    }));
  };
  const LeaveFilter = [
    { value: "all", label: "All" },
    { value: "full_day", label: "Full Day" },
    { value: "half_day", label: "Half Day" },
    { value: "2hrs_permission", label: "2 Hrs Permission" },
    { value: "comp_full_day", label: "Compensation Full Day" },
    { value: "comp_half_day", label: "Compensation Half Day" },
    { value: "wfh", label: "Work From Home" },
  ];

  // Current year
  const currentYear = dayjs().year();

  // Number of past years you want to include (e.g., last 15 years)
  const pastYearsCount = 30;

  // Generate list of years: current year and past years only
  const YearList = Array.from(
    { length: pastYearsCount + 1 },
    (_, i) => currentYear - i
  );
  // Month list
  const MonthList = [
    { value: "all", label: "All" },
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  //  const handleExport = async () => {
  //    try {
  //      const requestedData = {
  //        isExport: 1,
  //      };
  //      const response = await filterEntities("ot/reports", requestedData);
  //      if (response) {
  //        toast.success(response.message);
  //        const file_url = response.data?.fileUrl;
  //        // const link = document.createElement("a");
  //        // link.href = file_url;
  //        // link.setAttribute("download", "");
  //        // document.body.appendChild(link);
  //        // link.click();
  //        // link.remove();
  //        const link = document.createElement("a");
  //        link.href = file_url;
  //        link.setAttribute("download", "");
  //        document.body.appendChild(link);
  //        link.click();
  //        link.remove();
  //      }
  //    } catch (err) {
  //      toast.error(err?.response?.data?.message || err.message);
  //    } finally {
  //      handleCloseMenu();
  //    }
  //  };

  const fetchAllLeaveRequest = useCallback(
    async (employee_id, isExport = 0) => {
      setLoading(true);
      try {
        const queryParams = new URLSearchParams();
        queryParams.append("employee_id", employee_id);
        queryParams.append("isExport", String(isExport));

        const leaveTypeMap = {
          full_day: "1",
          half_day: "2",
          "2hrs_permission": "3",
          comp_full_day: "4",
          comp_half_day: "5",
          wfh: "6",
        };

        const selectedLeaveType =
          leaveFilter && leaveFilter !== "all"
            ? leaveTypeMap[leaveFilter]
            : "0";
        queryParams.append("leave_type_id", selectedLeaveType);

        const selectedMonth =
          monthFilter && monthFilter !== "all"
            ? String(monthFilter).padStart(2, "0")
            : "";
        const selectedYear = yearFilter || new Date().getFullYear();

        queryParams.append("month", selectedMonth);
        queryParams.append("year", selectedYear);

        const response = await getMyLeaveRequest(
          `leaverequest/monthlyReport?${queryParams.toString()}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // ✅ Handle export separately
        if (isExport === 1) {
          if (response?.success && response?.file_path) {
            toast.success(response.message || "Export successful!");
            // open file in new tab
            openInNewTab(response.file_path);
          } else {
            toast.error("Export failed. Please try again.");
          }
          return; // prevent running rest of logic
        }

        // ✅ Normal data fetch
        const formattedData = Array.isArray(response.data)
          ? response.data
          : response.data?.monthlyReport || [];

        setData(formattedData);
      } catch (error) {
        toast.error(error.message || "Failed to fetch leave requests.");
        console.error("Error fetching leaves:", error);
      } finally {
        setLoading(false);
      }
    },
    [leaveFilter, monthFilter, yearFilter, token]
  );

  // Normal fetch (no export)
  useEffect(() => {
    if (login_user?.id) {
      fetchAllLeaveRequest(login_user.id, 0);
    }
  }, [fetchAllLeaveRequest, login_user?.id]);

  const handleLeaveSubmitted = () => {
    if (login_user?.id) fetchAllLeaveRequest(login_user.id, 0);
    handleCloseLeave();
  };

  // ✅ New Export Handler
  const handleExport = () => {
    if (login_user?.id) {
      fetchAllLeaveRequest(login_user.id, 1);
    }
    handleCloseMenu();
  };

  return (
    <div style={{ padding: "16px" }} className="bg-white">
      <Box sx={{ width: "100%", backgroundColor: "transparent" }}>
        {/* Request Leave Offcanvas */}
        <Offcanvas
          show={showLeave}
          placement="end"
          className="custom-offcanvas"
          style={{ width: window.innerWidth <= 768 ? "80%" : "50%" }}
        >
          <OffcanvasBody className="p-0">
            <AddLeave
              onCancel={handleCloseLeave}
              onSuccess={handleLeaveSubmitted}
            />
          </OffcanvasBody>
        </Offcanvas>
        {/* Top Controls */}
        {/* <div className="d-flex align-items-center justify-content-between flex-nowrap gap-3"> */}
        <Box
          className="d-flex align-items-center justify-content-between flex-nowrap gap-3"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          {/* Filters LEFT */}
          <div className="d-flex align-items-center flex-nowrap">
            {/* Leave Type */}
            <div className="d-flex align-items-center">
              <Typography
                variant="body2"
                // sx={{ color: "#aaa", fontSize: "0.9rem", minWidth: "100px" }
                sx={{ color: isDarkMode ? "#9ca3af" : "#666", fontSize: "0.9rem", minWidth: "100px" }}
              >
                Leave Type
              </Typography>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                  value={leaveFilter}
                  onChange={(e) => setLeaveFilter(e.target.value)}
                  displayEmpty
                  sx={{ borderRadius: "5px" }}
                >
                  {LeaveFilter.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* Year */}
            <div className="d-flex align-items-center">
              <Typography
                variant="body2"
                sx={{
                  // color: "#aaa",
                    color: isDarkMode ? "#9ca3af" : "#666",
                  fontSize: "0.9rem",
                  minWidth: "100px",
                  textAlign: "center",
                }}
              >
                Year
              </Typography>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                  value={yearFilter}
                  onChange={(e) => setYearFilter(e.target.value)}
                  displayEmpty
                  sx={{ borderRadius: "5px" }}
                >
                  {YearList.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* Month */}
            <div className="d-flex align-items-center">
              <Typography
                variant="body2"
                sx={{
                  // color: "#aaa",
                  color: isDarkMode ? "#9ca3af" : "#666",
                  fontSize: "0.9rem",
                  minWidth: "100px",
                  textAlign: "center",
                }}
              >
                Month
              </Typography>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <Select
                  value={monthFilter}
                  onChange={(e) => setMonthFilter(e.target.value)}
                  displayEmpty
                  sx={{ borderRadius: "5px" }}
                >
                  {MonthList.map((month) => (
                    <MenuItem key={month.value} value={month.value}>
                      {month.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="d-flex align-items-center gap-3 flex-nowrap">
            <Button
              className="rounded text-capitalize AddButton me-2 ms-2"
              onClick={handleShowLeave}
            >
              Request Leave
            </Button>

            <Tooltip title="Export">
              <IconButton
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
                onClick={handleMenuOpen}
              >
                <SlOptions className="text-rgbr-blue" size={20} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              PaperProps={{ sx: { borderRadius: "8px" } }}
            >
              <MenuItem onClick={handleExport}>Export</MenuItem>
            </Menu>
          </div>
        {/* </div> */}
        </Box>
      </Box>

      {loading ? (
        <Loader />
      ) : (
        <div className="my-2">
          <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            <Table
              stickyHeader
              sx={{
                boxShadow: "none",
                borderCollapse: "collapse",
                "& td, & th": {
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                  borderBottom: "1px solid rgba(224, 224, 224, 1)",
                },
                // "& td:last-child, & th:last-child": {
                //   borderRight: "none", // remove extra right border
                // },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <Typography className="workstatus-header-cell">
                      Month
                    </Typography>
                  </TableCell>
                  <TableCell>Leave Type</TableCell>
                  <TableCell>
                    <Typography className="workstatus-header-cell">
                      Date
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography className="workstatus-header-cell">
                      Reason
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography className="workstatus-header-cell">
                      Status
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography className="workstatus-header-cell">
                      Count
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      sx={{ textAlign: "center", height: 200 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          fontSize: "16px",
                          fontWeight: "bold",
                          backgroundColor: isDarkMode ? "#272626" : "#f0f0f0",
                          color: isDarkMode ? "white" : "#888",
                        }}
                      >
                        No data found
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
                {data.map((dept, deptIndex) => (
                  <React.Fragment key={deptIndex /* Temporary static key */}>
                    {/* Department Row */}
                    <TableRow sx={{ backgroundColor: "transparent" }}>
                      <TableCell
                        sx={{
                          borderBottom: "1px solid rgba(224,224,224,1)",
                          verticalAlign: "top",
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={() => toggleDept(deptIndex)} // Use index for now
                        >
                          {expandedDepts[deptIndex] ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          borderRight: "1px solid rgba(224,224,224,1)",
                        }}
                      >
                        {dept.month}
                      </TableCell>
                      {[...Array(4)].map((_, i) => (
                        <TableCell
                          key={i}
                          sx={{ borderRight: "1px solid rgba(224,224,224,1)" }}
                        />
                      ))}
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          borderRight: "1px solid rgba(224,224,224,1)",
                        }}
                      >
                        {dept.total}
                      </TableCell>
                    </TableRow>

                    {expandedDepts[deptIndex] &&
                      (dept.data || []).map((leave, index) => (
                        <TableRow key={leave.leave_id}>
                          <TableCell /> {/* Expand icon cell */}
                          <TableCell>{leave.employee_name}</TableCell>
                          <TableCell>{leave.leave_type}</TableCell>
                          <TableCell style={{ minWidth: 200 }}>
                            {dayjs(leave.date_of_leave).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{
                              maxWidth: 200,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <Tooltip title={leave.dev_comments || ""}>
                              <Typography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: "default",
                                }}
                              >
                                {leave.dev_comments || "-"}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography
                                variant="body2"
                                className={
                                  leave.status?.toLowerCase() === "requested"
                                    ? "status-requested"
                                    : leave.status?.toLowerCase() === "declined"
                                    ? "status-declined"
                                    : leave.status?.toLowerCase() === "approved"
                                    ? "status-approved"
                                    : ""
                                }
                              >
                                {leave.status}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>1</TableCell>{" "}
                          {/* each leave counts as 1 */}
                        </TableRow>
                      ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </div>
  );
}

export default MonthlyReport;
